import api, { resolveUploadUrl } from '../config/api';

let cache = null;
let loadPromise = null;

export function invalidateCustomTeamLogosCache() {
  cache = null;
  loadPromise = null;
}

export async function loadCustomTeamLogos(force = false) {
  if (force) {
    invalidateCustomTeamLogosCache();
  }
  if (cache) return cache;
  if (!loadPromise) {
    loadPromise = api
      .get('/settings/team-logos')
      .then((res) => {
        cache = res.data?.logos && typeof res.data.logos === 'object' ? res.data.logos : {};
        return cache;
      })
      .catch(() => {
        cache = {};
        return cache;
      });
  }
  return loadPromise;
}

function normalizeKey(name) {
  return String(name || '')
    .trim()
    .replace(/\s+/g, ' ');
}

export function getCustomTeamLogoPath(teamName) {
  if (!cache || !teamName) return null;
  const key = normalizeKey(teamName);
  if (cache[key]) return cache[key];
  const lower = key.toLowerCase();
  for (const [k, v] of Object.entries(cache)) {
    if (k.toLowerCase() === lower && typeof v === 'string' && v.trim()) {
      return v.trim();
    }
  }
  return null;
}

export function getCustomTeamLogoUrl(teamName) {
  const path = getCustomTeamLogoPath(teamName);
  return path ? resolveUploadUrl(path) : null;
}

export function setCustomTeamLogo(teamName, logoPath) {
  const key = normalizeKey(teamName);
  if (!key || !logoPath) return;
  if (!cache) cache = {};
  cache[key] = logoPath;
}

export async function uploadTeamLogo(teamName, file) {
  const key = normalizeKey(teamName);
  if (!key) {
    throw new Error('Nom d\'équipe requis');
  }
  if (!file) {
    throw new Error('Fichier image requis');
  }

  const body = new FormData();
  body.append('teamName', key);
  body.append('logo', file);

  const { data } = await api.post('/settings/team-logos', body);
  if (data.logoUrl) {
    setCustomTeamLogo(key, data.logoUrl);
  } else if (data.logos) {
    cache = data.logos;
  }
  return data;
}
